import { useState } from 'react';
import { Title, useTranslate } from 'react-admin';
import { Box, Card } from '@mui/material';
import { ChannelType } from '../../types/chat.types';
import {
  ChannelTypeSelector,
  ZapyWizard,
  TelegramWizard,
  EmailWizard,
} from '../../components/channel';

export const ChannelCreate = () => {
  const translate = useTranslate();
  const [selectedChannel, setSelectedChannel] = useState<ChannelType | null>(null);

  const handleSelectChannel = (channelType: ChannelType) => {
    setSelectedChannel(channelType);
  };

  const handleBack = () => {
    setSelectedChannel(null);
  };

  // Render the appropriate wizard based on selected channel type
  const renderWizard = () => {
    switch (selectedChannel) {
      case ChannelType.ZAPY:
        return <ZapyWizard onBack={handleBack} />;
      case ChannelType.TELEGRAM:
        return <TelegramWizard onBack={handleBack} />;
      case ChannelType.EMAIL:
        return <EmailWizard onBack={handleBack} />;
      default:
        return null;
    }
  };

  return (
    <Box>
      <Title title={translate('resources.channel.create.title')} />

      {selectedChannel ? (
        renderWizard()
      ) : (
        <Card sx={{ mt: 2 }}>
          <ChannelTypeSelector onSelectChannel={handleSelectChannel} />
        </Card>
      )}
    </Box>
  );
};
